module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/185.0b24233a.png";